function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling?.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {

    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: false });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => {
        button.addEventListener('click', this.onButtonClick.bind(this));
      }
    );

  
    document.querySelector("#sqft_input")?.addEventListener("change", (e) => {
      this.formatInputWithCommas(e);
    });


    document.querySelector("#waste")?.addEventListener("change", (e) => {
      this.calculateAndUpdateFloorSizing(e);
    });


    document.querySelector('.quantity__input[name="quantity"]')?.addEventListener("change", (e) => {
      
      var selectedVariant = document.querySelector(".selected-product-variant").getAttribute("value");
      let inputValue = this.parseFormattedNumber(e);
      if (!isNaN(inputValue)) {
        let { totalBox, totalSqft, width, length } = this.calculateValues(
          -1,
          inputValue,
          false
        );
        if (document.querySelector("#sqft_input") != null) {
          document.querySelector("#sqft_input").value = this.formatNumber(totalSqft);
        }

        this.updateUI(totalBox, totalSqft, width, length);
      }
    });

    document.querySelector("#sqft_input")?.addEventListener("change", (e) => {
      let inputValue = this.parseFormattedNumber(e);
      if (!isNaN(inputValue)) {
        let { totalBox, totalSqft, width, length } = this.calculateValues(
          inputValue,
          -1,
          document.querySelector("#waste").checked
        );
        this.updateUI(totalBox, totalSqft, width, length);
      }
    });


  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  formatNumber(number) {
    const numberFormatter = new Intl.NumberFormat("en-US", {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return numberFormatter.format(number);
  }


  onInputChange(event) {
  //  this.validateQtyRules();
    const quantity = Math.max(this.input.value, this.input.getAttribute('min'));
    if (document.querySelector('.accessory-products__list-container__mobile') != null ) {
      document.querySelector('.accessory__quantity-input').value = quantity;
      document.querySelector('.accessory__quantity-input__mobile').value = quantity;
      document.querySelector(".main-product-card_for_accessory-products .accessory-card__quantity-display").innerHTML = ' Quantity: '+quantity;
      document.querySelector('.main-accessory-product__mobile .quantity-display').innerHTML = "&times; "+quantity;
    }

    //for anything sold in sqft(underlayment mostly), do the math to figure out the quantity needed
    document.querySelectorAll('.quantity-display[sf-per-box]')?.forEach(quantitySF => {
      //are we on desktop or mobile?
      var this_card = quantitySF.closest('.card');
      if (this_card == null) {
        var this_card = quantitySF.closest('.accessory-card__mobile')
      }


      if (this_card.classList.contains('main-product-card_for_accessory-products')) {
        return;
      }

      const mainProduct_sqft = parseInt(document.querySelector('.total-sqft').innerText.replace(',',''));
      const sf_per_box = quantitySF.getAttribute('sf-per-box');
      // console.log('main product sqft '+mainProduct_sqft + ' / sqft per box '+sf_per_box );
      var quantity = Math.ceil(mainProduct_sqft / sf_per_box);
      if (quantitySF.classList.contains('accessory-card__quantity-display')) {
        quantitySF.innerHTML = ' Quantity: '+quantity;
      } else {
        quantitySF.innerHTML = "&times; "+quantity;
      }
      
      if (this_card.querySelector('.accessory__quantity-input') != null) {
        this_card.querySelector('.accessory__quantity-input').value = quantity;
      }
      if (this_card.querySelector('.accessory__quantity-input__mobile') != null) {
        this_card.querySelector('.accessory__quantity-input__mobile').value = quantity;
      }

      const this_price = parseFloat(this_card.querySelector('.pricing-list').getAttribute('variant-price'));
      // console.log('this price '+this_price+' * quantity '+quantity);
      var recalculated_price = this_price * quantity;
      this_card.querySelector(".unformatted-price").innerHTML = recalculated_price;
      recalculated_price = recalculated_price.toLocaleString(undefined, {minimumFractionDigits: 2,maximumFractionDigits: 2});
      var formatted_price =
        "$<span class='whole-number'>" +
        recalculated_price.split(".")[0] +
        "</span>." +
        recalculated_price.split(".")[1];
      this_card.querySelector(".now-price").innerHTML = formatted_price;
    });
  }

  parseFormattedNumber(input) {
    return parseFloat(input.target.value.replace(/[^\d.]/g, ""));
  }

  formatInputWithCommas(input) {
    let value = input.target.value.replace(/,/g, ""); // Remove existing commas
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ","); // Add commas
    input.value = value;
  }


  calculateValues(
    areaValue = -1,
    boxValue = -1,
    includeWaste = false
  ) {
    // console.log("areaValue: "+areaValue+", "+boxValue);
    const selectedVariant = document.querySelector(`.selected-product-variant`).getAttribute("value");
    const box_size = document.querySelector(`.pricing-list[variant-id="${selectedVariant}"]`).getAttribute("data-sq-ft");
    const sqftPerBox = document.querySelector(`.pricing-list[variant-id="${selectedVariant}"]`).getAttribute("data-sq-ft");
    const width = document.querySelector(`.pricing-list[variant-id="${selectedVariant}"]`).getAttribute("variant-width");
    const minQty = document.querySelector('.quantity_section .quantity__input').getAttribute('min');
    
    // console.log(areaValue+", "+boxValue);
    if (boxValue > -1) {
      boxValue = Math.max(boxValue, minQty);
    }

    let wasteMultiplier = includeWaste ? 1.1 : 1;
    if (isNaN(areaValue) || areaValue === "") {
      areaValue = 0;
    }

    let total_sqft = 0;
    let total_box = 0;
    if (boxValue > -1) {
      
      total_sqft = boxValue * box_size;
      total_box = boxValue;
    } else if (areaValue > -1) {
      total_sqft = areaValue * wasteMultiplier;
      total_box = Math.max(Math.ceil(Math.max(total_sqft / box_size, 1),0),minQty);
    }


    let box_sqft = total_box * box_size;
    let length = Math.round((total_box * (sqftPerBox * 144)) / width, 0);
    // console.log(boxValue+", "+total_box+", "+total_sqft+", "+box_sqft);

    return {
      totalBox: total_box,
      totalSqft: box_sqft,
      width: width,
      length: length,
    };
  }



  calculateAndUpdateFloorSizing(event) {
    let inputValue = parseFloat(document.querySelector("#sqft_input").value.replace(/[^\d.]/g, ""));
    let includeWaste = event.target.checked;

    let { totalBox, totalSqft, width, length } = this.calculateValues(inputValue,-1,includeWaste);
    this.updateUI(totalBox, totalSqft, width, length);
  }

  updateUI(totalBox, totalSqft, width = 0, length = 0) {
    totalSqft = parseFloat(totalSqft.toFixed(2));
    // console.log('totalSqft:'+totalSqft+ ', totalBox:'+totalBox);
    if (document.querySelector('.sale-info .total-sqft')) {
      document.querySelector(".sale-info .total-sqft").innerText = this.formatNumber(totalSqft);
    }
    document.querySelector('.quantity__input[name="quantity"]').value = totalBox;
    document.querySelector('.quantity__input[name="quantity"]').click();
    document.querySelectorAll(".sheet-flooring-width").forEach(w => w.innerText = width);
    document.querySelectorAll(".sheet-flooring-length").forEach(l => l.innerText = length);

    // console.log(totalBox);
    if (totalBox > 1) {
      document.querySelector(".price-per-item__container quantity-input button").classList.remove("disabled");
      

    }

    if (totalBox > 0) {
      const variant = document.querySelector('.selected-product-variant').value;
      const price = parseFloat(document.querySelector('.pricing-list[variant-id="'+variant+'"]').getAttribute('variant-price'));
      const total = totalBox * price;
      document.querySelector('.PriceShow__mobile').querySelector('.pricePerUnit').innerHTML = "$" + total.toFixed(2);
    }
  }










  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    // console.log('initpages');
    // console.log(this.sliderItemsToShow);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    // console.log('resetpages');
    // this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      // console.log(this.currentPage);
      // console.log(this.sliderItemsToShow);
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
   //   this.prevButton.setAttribute('disabled', 'disabled');
    } else {
  //    this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
   //   this.nextButton.setAttribute('disabled', 'disabled');
    } else {
   //  this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
    // Check if sliderAutoplayButton exists
    if (this.sliderAutoplayButton) {
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    } else {
      console.warn('Slider autoplay button not found. Skipping autoplay setup.');
    }
  
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }
  

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input[type="radio"]').forEach(radio => radio.addEventListener('change', this.onVariantChange.bind(this)));
    this.locale = 'en';
    if (document.querySelector('input[name="locale_code"]')) {
      this.locale = document.querySelector('input[name="locale_code"]').value;
    }
  }


  onVariantChange() {
    console.log(this);
    this.updateOptions();
    this.updateMasterId();
    var addButtonText = ''
    if (this.currentVariant && this.currentVariant.available == false) {
      addButtonText = "Out of stock";
    }
    this.toggleAddButton(true, addButtonText, false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.renderProductInfo();
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.updatePrice();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    console.log(this.querySelectorAll('select'));
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const variantID = this.currentVariant.id;
    const sku = this.currentVariant.sku;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // console.log("this.dataset.section " + this.dataset.section + ", this.currentVariant " + this.currentVariant.featured_media.id);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (modalContent) {
      const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
    }
    
    // show or hide gallery thumbnails on whether they correspond with the selected sku
    document.querySelectorAll(`.thumbnail-list__item`).forEach(thumbnail => thumbnail.setAttribute('variant-featured','false'));
    var activeThumbnails = document.querySelectorAll(`.thumbnail-list__item[data-sku*="${sku}"], .thumbnail-list__item[data-sku="all"]`);

    // console.log(activeThumbnails);
    var thumbnailCount = 0;

    activeThumbnails = [...activeThumbnails];
    activeThumbnails = activeThumbnails.reverse();
    activeThumbnails.forEach((thumbnail) => {
      mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(thumbnail.getAttribute('data-target'), true));
      thumbnailCount++;
    });

    
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const sliderNext = document.querySelectorAll('.slider-button--next');
    const sliderPrev = document.querySelectorAll('.slider-button--prev');

    if (thumbnailCount > 5) {
      sliderNext.forEach((slider) => {
        slider.removeAttribute('disabled');
        slider.style.display = 'block';
      });
      document.querySelector('.thumbnail-slider').slider.scrollTo({ left: 0}); 
    } else {
      sliderNext.forEach((slider) => {
        slider.style.display = 'none';
        slider.setAttribute('disabled','disabled');
      });
    }

    //change the specs section to match the current variant
    document.querySelectorAll('.specs').forEach(specs => specs.style.display = 'none');
    document.querySelectorAll(`.specs[name="${variantID}"]`).forEach(specs => specs.style.display = 'inline-block');
    const label = document.querySelector(`label[variant-id="${variantID}"]`);
    if (label?.querySelector('.inner-color-image') != null) {
      var bg = window.getComputedStyle(label.querySelector('.inner-color-image')).backgroundImage;
      bg = bg.replace("url(", "").replace(")", "").replace(/\"/gi, "");
      document.querySelector(".f-30.m-0.mb-10 img")?.setAttribute('src',bg);
      document.querySelector(".f-30.m-0.mb-10 img")?.setAttribute('srcset',bg);
    }
    document.querySelectorAll(".f-30.m-0.mb-10 span").forEach(specs => specs.innerText = this.currentVariant.title);

    const mainImage = document.querySelector(".product__media-item.variant-main-image.is-active img").getAttribute('src');

    const singleSampleImage = document.querySelector(".single-sample-image");
    if (singleSampleImage != null) {
      singleSampleImage.setAttribute('srcset',mainImage);
    }

    const sampleText = document.querySelector('.sample-color');
    if (sampleText != null) {
      sampleText.innerHTML = `${this.currentVariant.option1}`;
    }

    //with custom paint, the alt text should only be set by the color selection which is handled in product-variant-picker
    const templateType = document.querySelector('product-info').getAttribute('template-type');
    if (templateType.includes("Custom Paint")) {
      // if this is a Custom Paint item,
      // and Untinted is selected, allow adding to cart without selecting color

      if (document.querySelector('input[value="Untinted"]:checked')?.length > 0) {
        document.querySelector(".button--primary").removeAttribute("disabled");
        document.querySelector(".button--primary > span").innerText = "Add to Cart";
        document.querySelector(".button--primary > b").innerText = "Add a Sample to Cart";
        document.querySelector(".paint-custom-color").value = "Untinted";
        document.querySelector(".custom-paint_fieldset").classList.add("disabled-fieldset");
      } else {
        //if Untinted is not selected then allow choosing color and disabled add to cart button until color has been selected
        document.querySelector(".custom-paint_fieldset").classList.remove("disabled-fieldset");
        const paintColor = document.querySelector(".paint-custom-color");
        if (paintColor.value == "none" || paintColor.value == "Untinted") {
          document.querySelector(".button--primary").setAttribute("disabled", "disabled");
          document.querySelector(".button--primary > span").innerText = "Select a color";
          document.querySelector(".button--primary > b").innerText = "Select a color";
        }
        if ($(".paint-custom-color").attr("sample") == "untinted") {
          document.querySelector("#sample-ProductSubmitButton > b").innerText = "Add Untinted Sample to Cart";
          document.querySelector("#sample-ProductSubmitButton1 > b").innerText = "Add Untinted Sample to Cart";
          document.querySelector("#sample-ProductSubmitButton").removeAttribute("disabled");
          document.querySelector("#sample-ProductSubmitButton1").removeAttribute("disabled");
        }
      }
    }

    if (document.querySelector(".selected-color") != null) {
      document.querySelector(".selected-color").innerText = this.currentVariant.option1;
    }

    document.querySelectorAll(".product__sku").forEach(sku => sku.innerHTML = '<span class="visually-hidden">Item:</span> Item #' + this.currentVariant.sku.toString());
    
    if (document.querySelector('.main-product-card_for_accessory-products') != null) {
      document.querySelector(".main-product-card_for_accessory-products .accessory-card__options-display").innerHTML = " - " + this.currentVariant.title;
    }

    document.querySelector(".roomvo-button")?.setAttribute("href","javascript: roomvo.startStandaloneVisualizer('','" +this.currentVariant.sku +"');");

    // document.querySelectorAll('.thumbnail-list_item--variant:not([variant-featured="true"])').forEach((element) => element.style.display = 'none');
    // document.querySelectorAll('.thumbnail-list_item--variant[variant-featured="true"]').forEach((element) => element.style.display = 'block');
    document.querySelectorAll('.thumbnail-list__item:not([variant-featured="true"])').forEach((element) => element.style.display = 'none');
    document.querySelectorAll('.thumbnail-list__item[variant-featured="true"]').forEach((element) => element.style.display = 'block');
  }

  updatePrice() {
    const country_code = document.querySelector('input[name="country_code"]').value;
    // console.log(country_code);
    const regular_price = this.currentVariant.price.toString();
    const variantID = this.currentVariant.id;
    var formatted_price = "$<span class='whole-number'>" + regular_price.slice(0,-2) + "</span>." + regular_price.slice(-2);
    if (country_code == 'CA') {
      formatted_price = formatted_price + ' CAD';
    }
    const mainAccessoryProductCard = document.querySelector('.main-product-card_for_accessory-products')

    if (mainAccessoryProductCard) {
      document.querySelector(".main-product-card_for_accessory-products .now-price").innerHTML = formatted_price;
    }

    if (this.currentVariant.unit_price != null) {
      const unitPrice = this.currentVariant.unit_price.toString();
      var formatted_price = "$<span class='whole-number'>" + unitPrice.slice(0,-2) +"</span>." + unitPrice.slice(-2);
      var formatted_price_per_unit = "$<span class='whole-number'>" + regular_price.slice(0,-2) + "</span>." + regular_price.slice(-2);
      var formatted_price_mobile = "$" + unitPrice.slice(0,-2) + "." + unitPrice.slice(-2) + " <span style='font-weight:normal;'>per sq. ft</span>";
      var regular_price_mobile = parseFloat(regular_price) * parseInt(document.querySelector('.quantity__input').value);
      var formatted_price_per_unit_mobile = "$" + regular_price_mobile.toString().slice(0,-2) + "</span>." + regular_price_mobile.toString().slice(-2);
      if (country_code == 'CA') {
        formatted_price = formatted_price + ' CAD';
        formatted_price_per_unit = formatted_price_per_unit + ' CAD';
      }

      document.querySelector('.price--large .pricePerUnit').innerHTML = formatted_price_per_unit;
      document.querySelector('.PriceShow__mobile').querySelector('.pricePerUnit').innerHTML = formatted_price_per_unit_mobile;
      document.querySelector('.price--large .final-price-sqft').innerHTML = formatted_price;
      document.querySelector('.PriceShow__mobile').querySelector('.final-price-sqft').innerHTML = formatted_price_mobile;
      if (this.locale == 'fr') {
        document.querySelector(".price--large .sq-ft-cover").innerHTML = "Couvre " + this.currentVariant.unit_price_measurement.quantity_value + " pieds carrés";
      } else {
        document.querySelector(".price--large .sq-ft-cover").innerHTML = "Covers " + this.currentVariant.unit_price_measurement.quantity_value + " sq. ft.";
      }
    } else {
      document.querySelector(".price--large .final-price").innerHTML = formatted_price;
    }

    // console.log('my save price is ' + save_price);
    var compareAt = this.currentVariant.compare_at_price;
    var savePrice = compareAt - this.currentVariant.price;
    if (this.currentVariant.unit_price) {
      compareAt = compareAt / parseFloat(this.currentVariant.unit_price_measurement.quantity_value); 
      savePrice = compareAt - this.currentVariant.unit_price;
    }
    compareAt = (compareAt / 100).toFixed(2);
    savePrice = (savePrice / 100).toFixed(2);
    var was_text = "Was: <span>$";
    var save_text = "Save: $";
    if (this.locale == 'fr') {
      was_text = "Était à <span>$";
      save_text = "Économisez $";
    }
    if (savePrice > 0) {
      document.querySelector(".sale-price-small").classList.remove("visibility-hidden");
      document.querySelector(".price--large .without-sale-price").innerHTML = was_text + compareAt + "</span>";
      document.querySelector(".price--large .sale-price-small").style.display = 'block';
      document.querySelector(".price--large .save_price").innerHTML = save_text + savePrice;

      console.log(save_text + savePrice);
      document.querySelector('.PriceShow__mobile .sale-price-small .without-sale-price').innerHTML = was_text + compareAt + "</span>";
      document.querySelector('.PriceShow__mobile .sale-price-small .save_price').innerHTML = save_text + savePrice;
      document.querySelector('.PriceShow__mobile .sale-price-small .without-sale-price').classList.remove('hide-on-mobile');
      document.querySelector('.PriceShow__mobile .sale-price-small .save_price').classList.remove('hide-on-mobile');
    } else {
      document.querySelector(".price--large .sale-price-small").style.display = 'none';
      document.querySelector('.PriceShow__mobile .sale-price-small .without-sale-price').classList.add('hide-on-mobile');
      document.querySelector('.PriceShow__mobile .sale-price-small .save_price').classList.add('hide-on-mobile');

    }

    document.querySelectorAll(`.pro-free-shipping[for="${variantID}"]`)?.forEach(a =>a.classList.remove('special-message'));
    document.querySelectorAll(`.pro-free-shipping:not([for="${variantID}"])`)?.forEach(a => a.classList.add('special-message'));

    var backordered = false;

    // console.log("variant is "+this.currentVariant.title);

    document.querySelectorAll("fieldset[primary-option] > input")?.forEach(a => {
      const firstOption = a.value;
      const secondOption = this.currentVariant.option2;
      const thirdOption = this.currentVariant.option3;
      var allOptions = firstOption;
      if (secondOption != null) {
        allOptions = allOptions + " / " + secondOption;
        if (thirdOption != null) {
          allOptions = allOptions + " / " + thirdOption;
        }
      }
      // firstOption = firstOption.replace(/['"\\]/g, '\\$&');
      
      // if (document.querySelector("#on-sale-variants")?.textContent.indexOf(allOptions+"*") > -1) {
      //   // we need to find all related thumbnails, images and references and add a sale badge
      //   $(`label[variant-name='${firstOption}']`).addClass("sale-badge-before");
      //   $(`label[variant-name='${firstOption}']`).find(".badge").show();
      //   $('.card__badge').show();
      // } else {
      //   $(`label[variant-name='${firstOption}']`).removeClass("sale-badge-before");
      //   $(`label[variant-name='${firstOption}']`).find(".popup_data").find(".product-link").find(".badge").hide();
      //   $('.card__badge').hide();
      // }
    });

    document.querySelectorAll(`.pro-backorder-text[for="${variantID}"]`).forEach(a => {
      a.classList.remove('special-message');
      if (a.getAttribute('allow-purchase') == 'false') {
        backordered = true;
        this.toggleAddButton(true,"Not Available",false)
      }
    });

    document.querySelectorAll(`.pro-backorder-text:not([for="${variantID}"])`).forEach(a => {
      a.classList.add('special-message');
    });

    if (document.querySelector("#discontinued-variants")?.textContent.indexOf(variantID) > -1) {
      this.toggleAddButton(true,'',false)
    } else {
      if (!backordered) {
        this.toggleAddButton(false,'',false)
      }
    }

    document.querySelectorAll(`.sale-info-msg[for="${variantID}"]`).forEach(s => s.classList.remove('special-message'));
    document.querySelectorAll(`.sale-info-msg:not([for="${variantID}"])`).forEach(s => s.classList.add('special-message'));

    document.querySelectorAll(".variant-id_for_accessory-products").forEach(v => v.value = variantID);

    if (document.querySelector("#on-sale-variants")?.textContent.indexOf(variantID) > -1) {
      document.querySelectorAll(".product__media-item")?.forEach(a => a.querySelector(".badge").classList.add("badge-sale"));
      document.querySelector('[data-sku*="' + variantID + '"][variant-featured="true"] .badge')?.classList.remove("hide-badge");
    } else {
      document.querySelectorAll(".product__media-item .badge")?.forEach(a => a.classList.remove("badge-sale"));
      document.querySelector('[data-sku*="' + variantID + '"][variant-featured="true"] .badge')?.classList.add("hide-badge");
    }

  
  }
  

  updateURL() {
    const requestedVariantId = this.currentVariant.id;
    var sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    const addButtonUpdated = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const isSoldOut = !this.currentVariant || this.currentVariant.available === false;
    var selectedSize = $('input[type="radio"][name="Size"]:checked').val(); // Get the selected size value
    // console.log('my selected size is ' + selectedSize);
    if (addButtonUpdated) {
        // Determine the button text based on availability
        var buttonText = isSoldOut 
            ? `Unavailable in ${selectedSize}` 
            : '';
        // this.toggleAddButton(isSoldOut, buttonText);
    } else {
      //  console.warn(`Button with ID ProductSubmitButton-${sectionId} not found.`);
        this.toggleAddButton(true, `Unavailable in ${selectedSize}`);
    }
    
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      
      const inputId = productForm.querySelector('input[name="id"]');
      const inputSku = productForm.querySelector('input[name="sku"]');
      inputId.value = this.currentVariant.id;
      inputSku.value = this.currentVariant.sku;
      // inputId.dispatchEvent(new Event('change', { bubbles: true }));
      // document.querySelector('#sqft_input')?.val('');
      document.querySelector('.quantity__input')?.dispatchEvent(new Event('change'));
    });

    document.querySelectorAll(`.pricing-list[variant-id="${this.currentVariant.id}"]`).forEach((thisVariant) => {
      var variant_id = thisVariant.getAttribute("variant-id");
      var sample_id = thisVariant.getAttribute("variant-sample");
      var variant_model = thisVariant.getAttribute("variant-vendor-item");
      var regular_price = thisVariant.getAttribute("variant-price");
      var stock = thisVariant.getAttribute('variant-inventory-quantity');
      var show_shipping_message = thisVariant.getAttribute('variant-show-shipping-message');
      var roomvo = thisVariant.getAttribute('variant-roomvo');

      document.querySelectorAll(`#addToCartFormSample input[name="id"]`).forEach(input => input.setAttribute("value",sample_id));
      document.querySelectorAll(`#addToCartFormSample1 input[name="id"]`).forEach(input => input.setAttribute("value",sample_id));
      if (
        variant_model === null ||
        variant_model === undefined ||
        variant_model === ""
      ) {
        document.querySelector(".model-id").innerHTML = "";
      } else {
        document.querySelectorAll(".model-id").forEach(model => model.innerHTML = "<span>Model</span> #" + variant_model);
        document.querySelectorAll(".model-id").forEach(model => model.classList.remove("visibility-hidden"));
      }

      if (show_shipping_message) {
        document.querySelectorAll('.shipping-estimate-message.freight').forEach(message => message.style.display = 'block');
      } else {
        document.querySelectorAll('.shipping-estimate-message.freight').forEach(message => message.style.display = 'none');
      }

      if (parseInt(stock) > 5) {
        document.querySelectorAll('.shipping-estimate-message.parcel').forEach(message => message.style.display = 'block');
      } else {
        document.querySelectorAll('.shipping-estimate-message.parcel').forEach(message => message.style.display = 'none');
      }

      if (document.querySelector('.roomvo-btn') != null) {
        if (roomvo == '0') {
          document.querySelector('.roomvo-btn').style.display = 'none';
        } else {
          document.querySelector('.roomvo-btn').style.display = 'block';
        }
      }
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    // console.log(this.getVariantData());
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      var prevIndex = index - 1
      if (prevIndex < 0) {
        prevIndex = inputWrappers.length - 1;
      }
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected && document.querySelector(`.pricing-list[variant-id="${variant.id}"]`).getAttribute('do-not-display') != 'true')
      .map(variantOption => variantOption[`option${ index + 1 }`]);
      if (index===0) {
        console.log(optionInputs);
        console.log(previousOptionSelected);
        console.log(availableOptionInputsValue);
        return;
      }
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
      // console.log(optionInputs);
      // console.log(availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    var sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;
        var template = $('product-info').attr('template-type');
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        if (template == 't') {
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        // dekstech custom functionality for Model # (vendor item number as a metafield on variant)

  const modelSource = html.querySelector('.model-id');
  const modelDestination = document.querySelector('.model-id');
  if (modelSource && modelDestination) {
    modelDestination.innerHTML = modelSource.innerHTML;
    modelDestination.classList.toggle('visibility-hidden', modelSource.classList.contains('visibility-hidden'));
  }

// end of dekstech custom functionality
              const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');
        }
        /* handled in update URL since it is faster update
        const addButtonUpdated = document.getElementById(`ProductSubmitButton-${sectionId}`);
        const isSoldOut = !this.currentVariant || this.currentVariant.available === false;
        
        if (addButtonUpdated) {
            this.toggleAddButton(isSoldOut, isSoldOut ? window.variantStrings.soldOut : '');
        } else {
            console.warn(`Button with ID ProductSubmitButton-${sectionId} not found.`);
            this.toggleAddButton(true, window.variantStrings.soldOut);
        }
*/
        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const model = document.querySelector('.model-id');
    const backorder = document.querySelector('.pro-backorder-text');
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (backorder) backorder.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (model) model.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    var resetChecked = false;
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        input.disabled = false;
        input.labels[0]?.classList.remove('disabled-label');
        
      } else {
        input.classList.add('disabled');
        input.disabled = true;
        input.labels[0]?.classList.add('disabled-label');
        if (input.checked == true) {
          resetChecked = true;
        }
      }
    });
    if (resetChecked) {
      const first = listOfOptions.find(input => listOfAvailableOptions.includes(input.getAttribute('value')));
      first?.labels[0].click();
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    console.log(this);
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
